
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Label_$reflection } from "../Shared/Category.js";
import { union_type, record_type, string_type, option_type, class_type, list_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState_$reflection, LabelId_$reflection, RequestedValue$1_$reflection } from "../Shared/Shared.js";
import { CategoryUtilizationDto_$reflection } from "../Shared/Utilization.js";

export class State extends Record {
    constructor(Categories, SelectedCategoryIds, StartDate, EndDate, Utilization, LevelFilter, FormState) {
        super();
        this.Categories = Categories;
        this.SelectedCategoryIds = SelectedCategoryIds;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Utilization = Utilization;
        this.LevelFilter = LevelFilter;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("UtilizationCheck.Types.State", [], State, () => [["Categories", RequestedValue$1_$reflection(list_type(Label_$reflection()))], ["SelectedCategoryIds", list_type(LabelId_$reflection())], ["StartDate", option_type(class_type("System.DateTime"))], ["EndDate", option_type(class_type("System.DateTime"))], ["Utilization", option_type(CategoryUtilizationDto_$reflection())], ["LevelFilter", option_type(string_type)], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CategoriesFetched", "SetCategories", "SetStartDate", "SetEndDate", "FetchUtilization", "UtilizationFetched", "ToggleLevelFilter", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("UtilizationCheck.Types.Msg", [], Msg, () => [[["Item", list_type(Label_$reflection())]], [["Item", list_type(LabelId_$reflection())]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", option_type(class_type("System.DateTime"))]], [], [["Item", CategoryUtilizationDto_$reflection()]], [["Item", string_type]], [["Item", class_type("System.Exception")]]]);
}

